<template>
  <div class="yimiao">
    <div>
      <div>
        <van-cell-group>
          <van-field
            v-model="datafrom.OrgName"
            required
            @click="OCodeshow = true"
            readonly="readonly"
            label="主办社区"
            placeholder="请选择主办社区"
          />
          <van-popup v-model="OCodeshow" position="bottom" get-container="body">
            <van-cascader
              title="请选择主办社区"
              :options="ocodelist"
              @close="OCodeshow = false"
              :field-names="{
                text: 'OrganName',
                value: 'OrganCode',
                children: 'Children',
              }"
              @finish="onocode"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.AKName"
            @click="fuwushow = true"
            readonly="readonly"
            label="活动分类"
            placeholder="请选择活动分类"
          />
          <van-popup v-model="fuwushow" position="bottom" get-container="body">
            <van-picker
              show-toolbar
              :columns="fuwuLists"
              value-key="Name"
              @cancel="fuwushow = false"
              @confirm="onfuwushow"
            >
            </van-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.Title"
            required
            label="活动标题"
            placeholder="请输入活动标题"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.Address"
            label="活动地址"
            placeholder="请输入活动地址"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.TimeLimitName"
            @click="timeLimit = true"
            readonly="readonly"
            required
            label="时间限制"
            placeholder="请选择时间限制"
          />
          <van-popup v-model="timeLimit" position="bottom" get-container="body">
            <van-picker
              show-toolbar
              :columns="timeList"
              value-key="name"
              @cancel="timeLimit = false"
              @confirm="onTimeLimit"
            >
            </van-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="datafrom.TimeLimit == 2">
          <van-field
            v-model="datafrom.StartTime"
            name="StartTime"
            label="开始时间"
            @click="StartTimeFend = true"
            readonly="readonly"
            placeholder="请选择开始时间"
          />
          <van-popup
            v-model="StartTimeFend"
            position="bottom"
            get-container="body"
          >
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="请选择开始时间"
              @cancel="StartTimeFend = false"
              @confirm="onStartTimeFend"
            >
            </van-datetime-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="datafrom.TimeLimit == 2">
          <van-field
            v-model="datafrom.EndTime"
            name="EndTime"
            label="结束时间"
            @click="EndTimeFend = true"
            readonly="readonly"
            placeholder="请选择结束时间"
          />
          <van-popup
            v-model="EndTimeFend"
            position="bottom"
            get-container="body"
          >
            <van-datetime-picker
              v-model="currentDate1"
              type="date"
              title="请选择结束时间"
              @cancel="EndTimeFend = false"
              @confirm="onEndTimeFend"
            >
            </van-datetime-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.TouchMan"
            label="联系人"
            placeholder="请输入联系人"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.TouchTel"
            label="联系电话"
            placeholder="请输入联系电话"
          />
        </van-cell-group>
        <!-- <van-cell-group>
          <van-field
            v-model="datafrom.SignupTypeName"
            @click="signup = true"
            readonly="readonly"
            required
            label="报名类型"
            placeholder="请选择报名类型"
          />
          <van-popup v-model="signup" position="bottom" get-container="body">
            <van-picker
              show-toolbar
              :columns="SignupTypelist"
              value-key="name"
              @cancel="signup = false"
              @confirm="onSignup"
            >
            </van-picker>
          </van-popup>
        </van-cell-group> -->
        <!-- <van-cell-group>
          <van-field
            type="number"
            v-model="datafrom.RecruitNum"
            label="招募人数"
            placeholder="招募人数"
          />
        </van-cell-group> -->
        <van-cell-group>
          <van-field
            type="number"
            v-model="datafrom.Score"
            label="积分奖励"
            placeholder="积分奖励"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.SortNum"
            label="排 序"
            placeholder="请输入排序码"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="datafrom.IssTime"
            name="IssTime"
            required
            label="发布时间"
            @click="IssTimeFend = true"
            readonly="readonly"
            placeholder="请选择发布时间"
          />
          <van-popup
            v-model="IssTimeFend"
            position="bottom"
            get-container="body"
          >
            <van-datetime-picker
              v-model="currentDate3"
              type="datetime"
              title="请选择发布时间"
              @cancel="IssTimeFend = false"
              @confirm="onIssTimeFend"
            >
            </van-datetime-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <div class="activity-title">活动内容</div>
          <div>
            <Editor :value.sync="datafrom.Content" style="width: 100%" />
          </div>
        </van-cell-group>

        <div>
          <span style="font-size: 14px; color: #333; margin: 0 17px"
            >缩略图</span
          >
          <van-uploader
            v-model="fileList"
            multiple
            class="imgActivity"
            :max-count="1"
            :after-read="afterRead"
            :deletable="true"
            @delete="shanchu"
            style="margin: 15px 22px"
          />
        </div>
        <div style="margin: 10px; display: flex">
          <span style="font-size: 14px; color: #333; margin: 0 17px">附件</span>
          <!-- :before-read="beforeRead" -->
          <div style="display: inline-block; flex: 1" v-if="datafrom.Annex">
            <a
              style="font-size: 14px; color: #4f4fef"
              :href="datafrom.Annex"
              target="_blank"
              >{{ datafrom.Annex }}</a
            >
          </div>
          <van-uploader
            v-else
            max-count="1"
            accept=".doc,.docx,.xls,.ppt,.txt,.pdf"
            :after-read="handleAvatarSucces"
            style="margin: 15px 22px"
          >
            <van-button icon="description" plain type="info"
              >上传附件</van-button
            >
          </van-uploader>
        </div>
        <van-cell-group>
          <van-field
            v-model="datafrom.Remark"
            label=" 备 注 "
            placeholder="请输入备注"
          />
        </van-cell-group>
      </div>
      <!-- <div class="buttons">
          <van-button type="info" @click="postfrom()">提交</van-button>
        </div> -->
      <div class="buttons">
        <van-button type="info" style="margin: 10px 0" @click="postfrom()"
          >发布</van-button
        >
        <!-- <van-button
          style="border: 1px solid #e6e6e6; margin: 10px 0"
          type="
            default"
          @click="fanhui()"
          >返回</van-button
        > -->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Dialog } from "vant";
import { Toast } from "vant";
import { getNickName, setToken } from "@/utils/auth";
import { GetOrganTree } from "@/api/Organ";
import { SaveActivity, WeGetInfoKindInfoPage } from "@/api/RealInfo";
Vue.use(Toast);
import {
  WeGetRegionList,
  WeGetBuildRoomList,
  WeGetAppletOrganList,
} from "@/api/yeguang";
import axios from "axios";
import config from "@/config";
import {
  WeSaveStaServiceSort,
  WeSaveProService,
  WeGetStaServiceSortPage,
} from "@/api/Lycal";
import Editor from "@/components/Editor";
import wx from "weixin-js-sdk";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Editor,
  },
  data() {
    return {
      ridlist: [],
      BRIdlist: [],
      ocodelist: [],
      fuwuLists: [],
      SerKindlist: [
        { value: 1, Name: "助餐" },
        { value: 2, Name: "助洁" },
        { value: 3, Name: "助行" },
        { value: 4, Name: "助浴" },
        { value: 5, Name: "助医" },
        { value: 6, Name: "康复" },
        { value: 7, Name: "巡访关爱" },
        { value: 8, Name: "辅助租赁" },
        { value: 99, Name: "其他" },
      ],
      idList: {
        organCode: "",
        // RId: undefined,
      },
      datafrom: {
        AId: 0, // 活动Id
        AKCate: 1,
        AKId: "", //分类Id、
        OrgName: "",
        OrgCode: "",
        Title: "", //活动标题、
        Address: "", // 活动地址
        TimeLimit: "", // 时间限制
        StartTime: "", // 开始时间
        EndTime: "", // 结束时间
        IssTime: "", // 发布时间
        IssMan: "",
        TouchMan: "", // 联系人
        TouchTel: "", // 联系电话
        SignupType: "2", // 报名类型
        RecruitNum: "0", // 招募人数
        Score: "0", // 积分奖励
        SortNum: "1", // 排序号、
        Describe: "", // 活动内容
        AImg: "", // 缩略图
        Annex: "", // 附件
        Remark: "", //备注
      },
      idListRId: false,
      OCodeshow: false,
      fuwushow: false,
      sexshow: false,
      fileList: [],
      uploadImgs: [],
      TitleList: [], // 资讯分类
      timeList: [
        {
          id: 1,
          name: "长期有效",
        },
        {
          id: 2,
          name: "限定时间",
        },
      ], // 时间限制
      timeLimit: false,
      signup: false,
      StartTimeFend: false,
      IssTimeFend: false,
      EndTimeFend: false,
      currentDate: new Date(),
      currentDate1: new Date(),
      currentDate3: new Date(),
      SignupTypelist: [
        { id: 1, name: "报名参加" },
        { id: 2, name: "仅通知" },
      ], // 报名类型
    };
  },
  created() {
    // var dataFrom = JSON.parse(this.$route.query.id);
    // this.datafrom = dataFrom;
    this.gitocodelist();
    this.getPBActivityList();
  },
  methods: {
    // 资讯分类
    getPBActivityList: function () {
      WeGetInfoKindInfoPage({ Cate: 1, limit: 99 }).then((res) => {
        this.fuwuLists = res.data.data;
      });
    },
    onStartTimeFend(val) {
      //开始时间确认
      this.datafrom.StartTime = this.dateformat(val);
      this.StartTimeFend = false;
    },
    onEndTimeFend(val) {
      //开始时间确认
      this.datafrom.EndTime = this.dateformat(val);
      this.EndTimeFend = false;
    },
    onIssTimeFend(val) {
      //发布时间确认
      this.datafrom.IssTime = this.dateformat1(val);
      this.IssTimeFend = false;
    },
    dateformat(val) {
      // 时间格式化事件 yy-mm-dd
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      return `${year}-${month}-${day}`;
    },
    // 上传 相关
    handleAvatarSucces(file) {
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          Toast.success("上传成功");
          //   var arr = this.uploadImgs;
          //   arr.push(res.data.data);
          //   this.uploadImgs = arr;
        }
        this.datafrom.Annex = res.data.msg;
      });
    },
    // 图片上传
    afterRead(file) {
      let c = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file);
      // 添加请求头
      axios.post(config.apiUploadUrl, formData, c).then((res) => {
        if (res.data.code === 0) {
          var arr = this.uploadImgs;
          arr.push(res.data.data);
          this.uploadImgs = arr;
        }
        this.datafrom.AImg = res.data.msg;
      });
    },
    // 图片删除
    shanchu: function () {
      this.datafrom.AImg = "";
    },

    // 提交
    postfrom: function () {
      console.log(this.datafrom);
      if (this.datafrom.OrgName == false) {
        Toast.fail("请选择主办社区");
        return false;
      }
      if (this.datafrom.Title == false) {
        Toast.fail("请输入活动标题");
        return false;
      }
      if (this.datafrom.TimeLimit == false) {
        Toast.fail("请选择时间限制");
        return false;
      }
      if (this.datafrom.IssTime == false) {
        Toast.fail("请选择发布时间");
        return false;
      }
      this.datafrom.IssMan = getNickName();
      SaveActivity(this.datafrom).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          Toast.success("发布成功");
          setTimeout(() => {
            if (window.__wxjs_environment === "miniprogram") {
              window.wx.miniProgram.reLaunch({
                url: "../public/goto?path=/article",
              });
            } else {
              this.$router.go(-1);
            }
          }, 1000);
          //   Dialog.alert({
          //     title: "提示",
          //     message: "提交成功!",
          //   }).then(() => {
          //     this.$router.push({
          //       path: "/CalYl/service",
          //     });
          //   });
        } else {
          Toast(res.data.msg);
          //   this.$router.go(-1);
        }
      });
    },
    fanhui: function () {
      this.$router.push({
        name: "/CalYl/service",
      });
    },
    // 服务类型选择器
    onsexshow(val) {
      this.datafrom.SerKind = val.value;
      this.datafrom.SerKindDesc = val.Name;
      this.sexshow = false;
    },
    // 活动分类选择器
    onfuwushow(val) {
      console.log(val);
      this.datafrom.AKId = val.AKId;
      this.datafrom.AKName = val.Name;
      this.fuwushow = false;
    },
    // 时间限制选择器
    onTimeLimit(val) {
      console.log(val);
      this.datafrom.TimeLimit = val.id;
      this.datafrom.TimeLimitName = val.name;
      this.timeLimit = false;
    },
    // 报名类型选择器
    onSignup(val) {
      console.log(val);
      this.datafrom.SignupType = val.id;
      this.datafrom.SignupTypeName = val.name;
      this.signup = false;
    },
    gitocodelist() {
      GetOrganTree().then((res) => {
        this.ocodelist = res.data.data;
      });
    },
    // 小区(组)列表
    RegionList: function (row) {
      WeGetRegionList({ organCode: row }).then((res) => {
        this.ridlist = res.data.data;
      });
    },
    // 房屋列表
    BuildRoomList: function (val) {
      WeGetBuildRoomList({
        bId: this.idList.BId,
        buId: this.idList.buId,
        bfId: val,
      }).then((res) => {
        console.log(res);
        this.BRIdlist = res.data.data;
      });
    },
    // 小区(组)选择器
    onidListRId(val) {
      this.datafrom.RId = val.RId;
      this.datafrom.Region = val.Title;
      this.idListRId = false;
      this.BuildList(val.RId);
    },
    // 社区
    onocode(val) {
      console.log(val);
      this.datafrom.OrgName = val.selectedOptions[0].OrganName;
      this.datafrom.OrgCode = val.selectedOptions[0].OrganCode;
      //   this.RegionList(val.value);
      this.OCodeshow = false;
    },
    dateformat1(val) {
      // 时间格式化事件 yy-mm-dd
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let houser = val.getHours();
      let Minutes = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (houser >= 1 && houser <= 9) {
        houser = `0${houser}`;
      }
      if (Minutes >= 1 && Minutes <= 9) {
        Minutes = `0${Minutes}`;
      }
      return `${year}-${month}-${day} ${houser}:${Minutes}` + ":00";
    },
  },
};
</script>
<style>
.yimiao .inputFrom {
  margin: 15px 8%;
}
.yimiao .inputFrom input {
  width: 80%;
  margin: 8px 8%;
  padding: 8px 5px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
}
.yimiao .buttons {
  text-align: center;
}
.yimiao .buttons button {
  width: 90%;
  margin: 25px 5%;
  border-radius: 10px;
}
.buttons {
  text-align: center;
}
.buttons button {
  margin: 25px 10px;
  border-radius: 10px;
}

.imgActivity {
  vertical-align: middle;
}
.activity-title {
  color: #646566;
  text-align: left;
  font-size: 14px;
  padding: 10px 16px;
}
</style>
